
    import * as React from 'react';

    const Exit24 = ({ color = 'currentcolor', height = '24px', width = '24px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 24 24" style={svgStyle}><path d="M12 11.323L19.323 4l.677.677L12.677 12 20 19.323l-.677.677L12 12.677 4.677 20 4 19.323 11.323 12 4 4.677 4.677 4 12 11.323z" /></svg>
        </div>
      );
    };

    Exit24.displayName = 'Exit24';

    export default Exit24;
  